import { champsSignataireEnum, champsSuiveurEnum } from '../components/popinAjout/popinAjoutSignataire/enums/champsSignataireEnum'
import { fileTypeEnum } from '../../../enum/procedure/fileEnum'
import { methodeAuthentification, positionSignature, typeSignataire } from '../components/popinAjout/types/popinAjoutInterneExterneModel'

export const INITIAL_CREATION_PROCEDURE: CreationProcedureModel = {
	signersValidators: [],
	mention: { hasMention: false, mentionText: '' },
	subscribers: [],
	name: '',
	expirationDate: null,
	uuid: '',
	signable_files: [],
	attachment_files: []
}

export interface FetchUUIDModel {
	uuid: string
}

export interface SignataireValidateurModel {
	[champsSignataireEnum.id]?: string,
	[champsSignataireEnum.nom]: string,
	[champsSignataireEnum.prenom]: string,
	[champsSignataireEnum.telephone]: string,
	[champsSignataireEnum.courriel]: string,
	[champsSignataireEnum.type]: typeSignataire
	[champsSignataireEnum.methodeAuth]?: methodeAuthentification
	[champsSignataireEnum.positionSignature]?: string
	[champsSignataireEnum.enregistrerDestinataire]?: boolean
}

export interface SignataireRechercheModel {
	[champsSignataireEnum.recherche]: string,
	[champsSignataireEnum.id]: string,
	[champsSignataireEnum.nom]: string,
	[champsSignataireEnum.prenom]: string,
	[champsSignataireEnum.telephone]: string,
	[champsSignataireEnum.courriel]: string,
	[champsSignataireEnum.type]: typeSignataire
	[champsSignataireEnum.methodeAuth]?: methodeAuthentification
	[champsSignataireEnum.positionSignature]?: positionSignature
	[champsSignataireEnum.enregistrerDestinataire]?: boolean
}

export interface SignataireValidateurListeModel {
	[champsSignataireEnum.nom]: string,
	[champsSignataireEnum.prenom]: string,
	[champsSignataireEnum.telephone]: string,
	[champsSignataireEnum.courriel]: string,
	[champsSignataireEnum.type]: typeSignataire,
	ordre: number,
	supprimer: number,
}

export interface SuiveurModel {
	[champsSuiveurEnum.nom]?: string,
	[champsSuiveurEnum.prenom]?: string,
	[champsSuiveurEnum.courriel]: string
}

export interface SuiveurRechercheModel {
	[champsSuiveurEnum.recherche]: string,
	[champsSuiveurEnum.nom]: string,
	[champsSuiveurEnum.prenom]: string,
	[champsSuiveurEnum.courriel]: string
}

export interface SuiveurListeModel {
	[champsSuiveurEnum.nom]?: string,
	[champsSuiveurEnum.prenom]?: string,
	[champsSuiveurEnum.courriel]: string,
	supprimer: number
}

export interface mentionModel {
	hasMention: boolean,
	mentionText: string
}

export interface CreationProcedureModel {
	signersValidators: SignataireValidateurModel[],
	mention: mentionModel,
	subscribers: SuiveurModel[],
	name: string,
	expirationDate: Date | null
	uuid: string,
	signable_files: SignableFile[],
	attachment_files: SignableFile[]
}

export interface SignableFile {
	filename: string
	paraphe?: boolean
	signaturePage?: string
	tapuscrite?: boolean
}

export interface AjoutFichierBackModel {
	name: string,
	fileData: string,
	uuid: string,
	type: fileTypeEnum.attachment | fileTypeEnum.signable
}

export interface SuppressionFichierBackModel {
	name: string,
	uuid: string,
	type: fileTypeEnum.attachment | fileTypeEnum.signable
}

export interface CreationProcedureContextModel {
	setFormValues: (formValues: CreationProcedureModel) => void
	formValues: CreationProcedureModel
}
